import React, { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';
// Imported from the module, not the `features/auth` barrel: the barrel is a
// `.js` file that re-exports the whole feature.
import { ProtectedRoute } from '../auth/components/ProtectedRoute';
import { RequireActiveAccount } from '../../router/guards';
import { NEW_SKILL_SEGMENT, SKILLS_ROUTE_SEGMENT } from './constants';

// One lazy chunk per page, pointing at the page module instead of the feature
// barrel, so importing this file from AppRouter does not pull the whole feature
// into the main bundle. The app's global <Suspense fallback={<RouteSkeleton />}>
// covers them.
const SkillsListPage = lazy(() =>
  import('./pages/SkillsListPage').then((module) => ({ default: module.SkillsListPage })),
);
const SkillEditorPage = lazy(() =>
  import('./pages/SkillEditorPage').then((module) => ({ default: module.SkillEditorPage })),
);

/**
 * Route subtree of the Skills MVP, mounted by AppRouter under an agent
 * (`accounts/:accountId/assistants/:AssistantID`).
 *
 * A `Route` element and not a component: `<Routes>` only accepts `Route`
 * children, and a wrapper component would break routing silently.
 *
 * **Currently gated by authentication and an active account only.** The module
 * owns `agent.skills.*` (`permissions.ts`), but the backend seed does not grant
 * them yet, and `can()` is an exact-string lookup — gating on them would lock
 * everyone but a superadmin out of the whole section. Re-gating is one edit per
 * route: `requiredPermission={SKILLS_PERMISSIONS.view}` on the parent and
 * `.create` on `new`.
 *
 * `new` is declared before `:skillId` so a skill id could never shadow it.
 */
export const skillsRoutes = (
  <Route
    path={SKILLS_ROUTE_SEGMENT}
    element={
      <ProtectedRoute>
        <RequireActiveAccount>
          <Outlet />
        </RequireActiveAccount>
      </ProtectedRoute>
    }
  >
    <Route index element={<SkillsListPage />} />
    <Route path={NEW_SKILL_SEGMENT} element={<SkillEditorPage />} />

    <Route path=":skillId" element={<SkillEditorPage />} />
  </Route>
);
